var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { trimEndSlash, getTokenRequestParameters, parseAuthAPIResponse } from "../../helpers";
import { SEAMLESS_ENDPOINTS, RequestMethods } from "../../constants";
export class SeamlessRequestService {
    constructor(url, operatorAuthTokenId, ajaxService, pageMethods, makeTokenRequest) {
        this.baseApiUrl = url;
        this.ajaxService = ajaxService;
        this.operatorAuthTokenId = operatorAuthTokenId;
        this.pageMethods = pageMethods;
        this.makeTokenRequest = makeTokenRequest;
    }
    getAnonymousToken() {
        const url = `${trimEndSlash(this.baseApiUrl)}/${SEAMLESS_ENDPOINTS.ANONYMOUS}`;
        const options = this.getAnonymousRequestOptions();
        const parameters = getTokenRequestParameters(url, parseAuthAPIResponse, options);
        return this.makeTokenRequest(this.ajaxService, parameters);
    }
    getAnonymousRequestOptions() {
        return {
            headers: {
                domainId: this.operatorAuthTokenId
            },
            method: RequestMethods.POST
        };
    }
    getLoginToken(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.callLoginMethod(params);
            const result = JSON.parse(response);
            if (result.jwtToken) {
                return result.jwtToken;
            }
            throw new Error(result.error);
        });
    }
    callLoginMethod(params) {
        return new Promise((resolve, reject) => {
            this.pageMethods.SeamlessTokenLogin(params.token, params.playerId, resolve, (response) => reject(new Error(response)));
        });
    }
    getRenewedToken(token) {
        const url = `${trimEndSlash(this.baseApiUrl)}/${SEAMLESS_ENDPOINTS.RENEW}`;
        const options = this.getRenewRequestOptions(token);
        const parameters = getTokenRequestParameters(url, parseAuthAPIResponse, options);
        return this.makeTokenRequest(this.ajaxService, parameters);
    }
    getRenewRequestOptions(token) {
        return {
            headers: {
                domainId: this.operatorAuthTokenId,
                authorization: `Bearer ${token}`
            },
            method: RequestMethods.POST
        };
    }
    logout(token) {
        return __awaiter(this, void 0, void 0, function* () {
        });
    }
}
//# sourceMappingURL=SeamlessRequestService.js.map